import { HTMLAttributes, memo } from 'react';

import { cn } from '../../lib/styles';

export type NotificationBadgeProps = Omit<HTMLAttributes<HTMLDivElement>, 'children'> & {
  count: number;
};

const NotificationBadgeBase = ({ count, className, style, ...rest }: NotificationBadgeProps) => {
  return (
    <div
      data-slot="notification-badge"
      className={cn(
        'inline-flex size-4.5 shrink-0 items-center justify-center p-0 rounded-full',
        'font-body-xs font-semibold tabular-nums text-gray-1',
        'border border-gray-3 bg-blue-6',
        'hover:bg-blue-6 hover:text-gray-1',
        className,
      )}
      style={{
        fontSize: count > 99 ? 6 : count > 9 ? 8 : 10,
        ...style,
      }}
      {...rest}
    >
      {count}
    </div>
  );
};

export const NotificationBadge = memo(NotificationBadgeBase);
